import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useUser } from '../Context/User';

export default function PrivateRoute({ fallback, children, ...props }) {
    const { token } = useUser();
    let data = localStorage.getItem('token');
    return (
        <Route
            {...props}
            render={({ location }) => {
                if (!token || data === null) {
                    return children;
                } else {
                    return (
                        <Redirect
                            to={{
                                pathname: fallback,
                                state: { from: location },
                            }}
                        />
                    );
                }
            }}
        />
    );
}
